import { Box, Typography } from "@mui/material";
import CustomerLogo from "Images/CustomerLogo.png";
import { useSelector } from "react-redux";
import { selectCustomerLogo, selectHeaderText, selectSubheaderText } from "slices/customerThemeSlice";

export default function Header() {
  const dynamicLogo = useSelector(selectCustomerLogo) || CustomerLogo;
  const headerText = useSelector(selectHeaderText);
  const subheaderText = useSelector(selectSubheaderText);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: "center",
        justifyContent: "center",
        gap: { xs: 2, sm: 7 },
        mx: { xs: 0, sm: 4 },
      }}
    >
      <Box component="img" sx={{ content: `url(${dynamicLogo})`, height: { xs: "40px", sm: "56px" } }}></Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: { xs: "center", sm: "flex-start" },
          textAlign: { xs: "center", sm: "start" },
        }}
      >
        <Typography variant="h1">{headerText}</Typography>
        <Typography variant="p" sx={{ display: { xs: "none", sm: "block" }, mt: 1 }}>
          {subheaderText}
        </Typography>
      </Box>
    </Box>
  );
}
